export default {
    'ALFA TOP ACOES FIC FIA IQ': 'ALFA TOP AÇÕES FIC FIA IQ',
    'RAIZPREV ENTIDADE DE PREVIDENCIA PRIVADA - Plano Agressivo': 'RAIZPREV ENTIDADE DE PREVIDENCIA PRIVADA',
    'RAIZPREV ENTIDADE DE PREVIDENCIA PRIVADA - Plano Moderado': 'RAIZPREV ENTIDADE DE PREVIDENCIA PRIVADA',
    'RAFIC EDUARDO JANSCH CHARTOUNY': 'RAFIC EDUARDO JANSCH CARTOUNY',
    'PREVIPLAN SOCIEDADE DE PREVIDENCIA PRIVADA - Plano Agressivo': 'PREVIPLAN SOCIEDADE DE PREVIDENCIA PRIVADA',
    'PREVIPLAN SOCIEDADE DE PREVIDENCIA PRIVADA - Plano Moderado': 'PREVIPLAN SOCIEDADE DE PREVIDENCIA PRIVADA',
    'LNX FIM IE CREDITO PRIVADO IP': 'LNX FIM IE CREDITO PRIVADO IQ',
    'JOSE FELIPE VIEIRA DE CASTRO': 'JOSÉ FELIPE VIEIRA DE CASTRO',
    'ILHA BELA CRED PRI INV EXTRIOR IP': 'ILHABELA FIA IP',
    'FUTURA II ENTIDADE DE PREV COMPLEMENTAR - Perfil Agressivo': 'FUTURA II ENTIDADE DE PREV COMPLEMENTAR',
    'FUTURA II ENTIDADE DE PREV COMPLEMENTAR - Perfil Moderado': 'FUTURA II ENTIDADE DE PREV COMPLEMENTAR',
    'ALOCC ACOES FIC DE FIA': 'ALOCC ACOES TNA FIC DE FIA',
    'LEBLON ACOES II  FIC FIA AGORA': 'LEBLON ACOES II FIC FIA AGORA',
    'DIOLIPE FIM CRED PRIV IE  IP': 'DIOLIPE FIM CRED PRIV IE IP',
    'JOSE MARIA DA CAMARA C VASCONCELLOS E SA': 'JOSE MARIA DE C C VASCONCELLOS E SA',
    'NEOS PREVIDENCIA COMPLEMENTAR - Celpos/Néos - Plano CD': 'NEOS PREVIDENCIA COMPLEMENTAR'
}